export default "__VITE_ASSET__0dFyG95o__"